import { CommonModule } from "@angular/common";
import { Component, inject, Input } from "@angular/core";
import { FormsModule } from "@angular/forms";
import { MatMenuModule } from "@angular/material/menu";
import { MatSelectModule } from "@angular/material/select";
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { Store } from "@ngrx/store";
import { Observable } from "rxjs";
import { ZorroTableComponent } from "../../../../components/common/custom-table/zorro-table.component";
import { LoadingComponent } from "../../../../components/common/loading/loading.component";
import { AddPayloadParamModalComponent } from "../../../../components/modal-templates/add-payload-param-modal/add-payload-param-modal.component";
import { FormModalComponent } from "../../../../components/modal-templates/form-modal/form-modal.component";
import {
  addHeaderFields,
  addParameterFields,
} from "../../../../core/generic-templates/dynamic-form-template";
import { AutomationActions } from "../../../../core/ngrx/actions/automation.actions";
import {
  selectOperationHeaders,
  selectOperationParameters,
  selectOperationParametersLoading,
} from "../../../../core/ngrx/selectors/automation.selectors";
import { ProjectService } from "../../../../core/services/project/project.service";
import { ToasterService } from "../../../../core/services/toaster-service";
import { MaterialModule } from "../../../../core/shared/material.module";
import {
  headerTableColumns
} from "../../../../core/table-templates/header-table";
import {
  parameterTableColumns
} from "../../../../core/table-templates/param-table";

@Component({
  selector: "app-parameter-tab",
  standalone: true,
  imports: [
    CommonModule,
    FormsModule,
    LoadingComponent,
    MaterialModule,
    MatSelectModule,
    MatMenuModule,
    ZorroTableComponent,
  ],
  templateUrl: "./parameter-tab.component.html",
  styleUrl: "./parameter-tab.component.scss",
})
export class ParameterTabComponent {
  private modalService = inject(NgbModal);
  iconSrcDelete: string =
    "../../../../../assets/images/virtusa-icons/remove-icon-dark.svg";
  isLoading: boolean = false;
  selectedParameters: any = [];
  selectedHeaders: any = [];
  isHeaderComponent: boolean = false;
  columns: any = [];
  rows: any = [];
  selectedPayloadParams: any = [];
  selectedParams: any = [];
  parameters$!: Observable<any>;
  headers$!: Observable<any>;
  projectId: string = "";
  automationProjectId: string = "";
  serviceId: string = "";
  operationId: string = "";
  operationData: any;
  loadingParams$: Observable<boolean> = this.store.select(
    selectOperationParametersLoading
  );
  @Input() data: string = "";

  constructor(
    public store: Store,
    public projectService: ProjectService,
    private readonly toaster: ToasterService
  ) {}

  ngOnInit(): void {
    this.projectService.getProjectId().subscribe((id: any) => {
      this.projectId = id;
    });

    this.loadingParams$.subscribe((loading) => {
      this.isLoading = loading;
    });

    this.projectService.getAutomationProjectId().subscribe((id: any) => {
      this.automationProjectId = id;
    });

    this.projectService.getServiceId().subscribe((id: any) => {
      this.serviceId = id;
    });
    this.projectService.getOperationId().subscribe((id: any) => {
      this.operationId = id;
    });

    if (this.data === "header") {
      this.isHeaderComponent = true;
      this.columns = headerTableColumns;
      this.headers$ = this.store.select(selectOperationHeaders);
      this.headers$.subscribe((services) => {
        this.rows = services?.map((element: any) => ({
          ...element
        }));
      });
    } else {
      this.isHeaderComponent = false;
      this.columns = parameterTableColumns;
      this.parameters$ = this.store.select(selectOperationParameters);
      this.parameters$.subscribe((services) => {
        this.rows = services?.map((element: any) => ({
          ...element,
          id: element.paramId,
        }));
        console.log(this.rows);
      });
    }
  }

  removeParameter() {
    this.store.dispatch(
      AutomationActions.deleteOperationParameters({
        projectId: this.projectId,
        automationProjectId: this.automationProjectId,
        serviceId: this.serviceId,
        operationId: this.operationId,
        idList: this.selectedParameters.map((item: any) => item.id),
      })
    );
  }

  changeRemoveIcon(isActive: boolean) {
    this.iconSrcDelete = isActive
      ? "../../../../../assets/images/virtusa-icons/remove-icon-light.svg"
      : "../../../../../assets/images/virtusa-icons/remove-icon-dark.svg";
  }

  addNewPayloadParam(isEdit?: boolean, param?: any) {
    let id = param?.data?.row?.id;
    const modalRef = this.modalService.open(AddPayloadParamModalComponent, {
      centered: true,
      size: "lg",
      backdrop: 'static',
    });
    modalRef.componentInstance.model = isEdit ? param?.data?.row : null;
    modalRef.result.then((result) => {
      console.log(result);
      if (result) {
        // {
        //   "name": "userId7",
        //    "type": "Query",
        //     "payloadType": "Raw",
        //      "contentType": "APPLICATION_JSON_UTF8"
        //      }
        const ct = result?.contentType;

        if (
          (typeof ct === "string" && ct.trim()) ||
          (Array.isArray(ct) && ct.length)
        ) {
          if (typeof ct === "string") {
            this.dispatchParam({
              name: "Payload",
              type: result?.payloadType,
              payloadType: result?.payloadType,
              contentType: ct,
              paramType: "PAYLOAD_PARAMETER"
            }, id, isEdit );
          } else {
            ct.forEach((item: any) => {
              this.dispatchParam({
                name: item.key,
                type: this.getType(result?.payloadType, item.type),
                payloadType: result?.payloadType,
                paramType: "PAYLOAD_PARAMETER"
              }, id, isEdit);
            });
          }
        } else {
          this.dispatchParam(
            {
              ...result,
              paramType: "PAYLOAD_PARAMETER",
            },
            id,
            isEdit
          );
        }
      }
    });
  }

  getType(payloadType:string, type:string){
    switch (payloadType) {
      case "X_WWW_FORM_URL_ENCODED":
        return "URL_ENCODED";
      case "FORM_DATA":
        if(type === "file"){
          return "FORM_FILE";
        } else{
          return "FORM_TEXT";
        }
        default:
          return type;
    }
  }


  dispatchParam(payload: any, id: string, isEdit?: boolean) {
    if (isEdit) {
      this.store.dispatch(
        AutomationActions.updateOperationParameter({
          projectId: this.projectId,
          automationProjectId: this.automationProjectId,
          serviceId: this.serviceId,
          operationId: this.operationId,
          id: id,
          changes: payload,
        })
      );
    } else {
      this.store.dispatch(
        AutomationActions.addOperationParameter({
          projectId: this.projectId,
          automationProjectId: this.automationProjectId,
          serviceId: this.serviceId,
          operationId: this.operationId,
          operationParameters: payload,
        })
      );
    }
  }

  addNewRequestParam(isEdit?: boolean, param?: any) {
    const modalRef = this.modalService.open(FormModalComponent, {
      centered: true,
      backdrop: 'static',
    });
    modalRef.componentInstance.fields = addParameterFields;
    modalRef.componentInstance.model = isEdit ? param?.data?.row : null;
    modalRef.componentInstance.title = isEdit
      ? "Edit Request Parameter"
      : "Add Request Parameter";
    modalRef.componentInstance.buttonText = isEdit
      ? {
          primary: "Update",
          secondary: "Cancel",
        }
      : {
          primary: "Add",
          secondary: "Cancel",
        };
    modalRef.result.then((result) => {
      console.log(result);
      if (result) {
        // {
        //   name:"",
        //   type:""
        //   paramType: "RequestParameter"
        // }
        let payload = {
          ...result,
          paramType: "REQUEST_PARAMETER",
        };
        if (isEdit) {
          this.store.dispatch(
            AutomationActions.updateOperationParameter({
              projectId: this.projectId,
              automationProjectId: this.automationProjectId,
              serviceId: this.serviceId,
              operationId: this.operationId,
              id: param?.data?.row?.id,
              changes: payload,
            })
          );
        } else {
          this.store.dispatch(
            AutomationActions.addOperationParameter({
              projectId: this.projectId,
              automationProjectId: this.automationProjectId,
              serviceId: this.serviceId,
              operationId: this.operationId,
              operationParameters: payload,
            })
          );
        }
      }
    });
  }

  handleRowSelection(event: any) {
    if (this.isHeaderComponent) {
      this.selectedHeaders = event.data;
      this.selectedParameters = [];
    } else {
      this.selectedParameters = event.data;
      this.selectedHeaders = [];
    }
  }

  handleTableActions(event: any) {
    if (event.type == "svg") {
      if (this.isHeaderComponent) {
        this.addNewHeader(true, event);
      } else {
        if (event?.data?.row?.paramType == "PAYLOAD_PARAMETER") {
          this.addNewPayloadParam(true, event);
        } else {
          this.addNewRequestParam(true, event);
        }
      }
    }
  }

  addNewHeader(isEdit?: boolean, header?: any) {
    const modalRef = this.modalService.open(FormModalComponent, {
      centered: true,
      backdrop: 'static',
    });
    modalRef.componentInstance.fields = addHeaderFields;
    modalRef.componentInstance.model = isEdit ? header?.data?.row : null;
    modalRef.componentInstance.title = isEdit ? "Edit Header" : "Add Header";
    modalRef.componentInstance.buttonText = isEdit
      ? {
          primary: "Update",
          secondary: "Cancel",
        }
      : {
          primary: "Add",
          secondary: "Cancel",
        };
    modalRef.result.then((result) => {
      console.log(result);
      if (result) {
        if (isEdit) {
          this.store.dispatch(
            AutomationActions.updateOperationHeader({
              projectId: this.projectId,
              automationProjectId: this.automationProjectId,
              serviceId: this.serviceId,
              operationId: this.operationId,
              id: header?.data?.row?.id,
              changes: result,
            })
          );
        } else {
          this.store.dispatch(
            AutomationActions.addOperationHeader({
              projectId: this.projectId,
              automationProjectId: this.automationProjectId,
              serviceId: this.serviceId,
              operationId: this.operationId,
              operationHeaders: result,
            })
          );
        }
      }
    });
  }

  removeHeaders() {
    this.store.dispatch(
      AutomationActions.deleteOperationHeader({
        projectId: this.projectId,
        automationProjectId: this.automationProjectId,
        serviceId: this.serviceId,
        operationId: this.operationId,
        idList: this.selectedHeaders.map((item: any) => item.id),
      })
    );
  }
}
